import * as classes from "./biome-master.module.scss";
import content from "../../content.json";
import { AppContext } from "../../contexts/AppContext";
import Button from "../Button/Button";
import IconCL from "../../icons/IconCL.svg";
import IconFF from "../../icons/IconFF.svg";
import IconFT from "../../icons/IconFT.svg";
import IconCash from "../../icons/IconCash.svg";
import confetti from "canvas-confetti";
import { useEffect, useRef, useContext } from "react";
import {} from "react";
import { useAnimate } from "./PlantModal";

const BiomeMasterModal = () => {
  const [rotXCurrent, rotYCurrent] = useAnimate();
  const { state } = useContext(AppContext);
  const { discountCode } = state;
  const canvasRef = useRef();

  useEffect(() => {
    const c = confetti.create(canvasRef.current, {
      resize: true,
      disableForReducedMotion: true,
      useWorker: true,
    });

    const to = setTimeout(() => {
      c({
        particleCount: 60,
        spread: 160,
        shapes: ["square"],
        colors: ["#7DFF87", "#60FD95", "#00FF12", "#DDFF7D", "#BEFF7D"],
        scalar: 1.6,
        ticks: 150,
        startVelocity: 35,
        origin: {
          x: 0.5,
          y: 0.5,
        },
        // any other options from the global
        // confetti function
      });
    }, 888);

    return () => {
      c.reset();
      clearTimeout(to);
    };
  }, []);
  return (
    <div
      className={classes.root}
      style={{
        transform: `rotateX(${rotXCurrent}deg) rotateY(${rotYCurrent}deg)`,
      }}
    >
      <h2
        className={classes.heading}
        dangerouslySetInnerHTML={{ __html: content.uiCopy.discountCodeHeading }}
      />
      <p
        className={classes.body}
        dangerouslySetInnerHTML={{ __html: content.uiCopy.discountCodeBody }}
      />
      <span className={classes.discount}>{discountCode || "Loading..."}</span>
      <Button label="See It" href={content.discountCodeShopUrl} type="link" />
      <IconCL className={classes.cl} />
      <IconFT className={classes.ft} />
      <IconFF className={classes.ff} />
      <IconCash className={classes.cash} />
      <canvas ref={canvasRef} className={classes.confetti}></canvas>
    </div>
  );
};

export default BiomeMasterModal;
